import config from '@/lib/config';
import TaggedActivity from '../templates/metrics/TaggedActivity';

const InternalMeetings = new TaggedActivity({
  name: 'InternalMeetings',
  tag: config.INSIGHTS.TAGS.INTERNAL_MEETINGS,
});

export default InternalMeetings;
